import request from '../../utils/request';
import qs from 'qs'
import { get } from 'core-js/core/dict';

export function synchWeStaff(Authorization){
  return request({
    url: '/api/qywechat/synchWeStaff',
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}

export function getStaffsInfo(param, Authorization, inputContent) {
  return request({
    url: '/api/qywechat/getStaffsInfos?query=' + inputContent,
    method: 'post',
    data: param,
    headers: {
      "authorization": Authorization
    }
  })
}

export function getChatAuditStaffsInfo(param, Authorization) {
  return request({
    url: '/api/qywechat/getChatAuditStaffsInfo',
    method: 'post',
    data: param,
    headers: {
      "authorization": Authorization
    }
  })
}

export function getContactList(pram,Authorization,isloading) {
  return request({
    // url: '/api/qywechat/getQwContactList/' + 'sendFrom=' + sendFrom + '&startTime=' + startTime + '&endTime=' + endTime + '&current=' +current+ '&size=' + size + '&name=' + name ,
    url: '/api/qywechat/getQwContactList/' + pram.sendFrom + '/' + pram.current + '/' + pram.size + '/' + pram.startTime + '/' + pram.endTime ,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  },isloading)
}

export function getDialogInfo(sendFrom,sendTo,current,size, Authorization,isloading,msgType) {
  let url = '/api/qywechat/getQwStaffDialog/'+sendFrom+'/'+sendTo+'/'+current+'/'+size
  if(msgType) {
    url = url + `?msgType=${msgType}`
  }
  return request({
    // url: '/api/qywechat/getQwStaffDialog?'+'sendFrom='+sendFrom+'&sendTo='+sendTo+'&current='+current+'&size='+size,
    url,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  },isloading)
}

export function getDepartmentList(authorization){
  return request({
    url: '/api/qywechat/getDepartmentList',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}

export function getDepartmentStaff(departmentId, departmentName, parameter, authorization){
  return request({
    url: '/api/qywechat/getDepartmentStaff/' + departmentId + '/' + departmentName,
    method: 'post',
    data: parameter,
    headers: {
      "authorization": authorization
    }
  })
}

export function setStatffStatus(userId, status, authorization){
  return request({
    url: '/api/qywechat/setStaffStatus/' + userId + '/' + status,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}

export function setStaffAppStatus(userId, appStatus, authorization){
  return request({
    url: '/api/qywechat/setStaffAppStatus/' + userId + '/' + appStatus,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}

// 获取院内的信息列表
export function getEmpBind(params,authorization){
  return request({
    url: '/api/qywechat/getEmpBind',
    params,
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}

// 员工绑定--获取院内的部门
export function getEmpDepart(authorization){
  return request({
    url: '/api/qywechat/getEmpDepart',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}

// 员工绑定
export function saveEmpBind(param, authorization){
  return request({
    url: '/api/qywechat/saveEmpBind',
    method: 'post',
    data: param,
    headers: {
      "authorization": authorization
    }
  })
}
// 员工解绑
export function deleteEmpBind(data,authorization){
  return request({
    url: '/api/qywechat/deleteEmpBind',
    data,
    method: 'delete',
    headers: {
      "authorization": authorization
    }
  })
}
// 员工管理--同步通讯录
export function syncWeStaffInformal(authorization,isloading){
  return request({
    url: '/api/qywechat/syncWeStaffInformal',
    method: 'post',
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 员工管理--启用账号数占比
export function getLicensePoint(authorization){
  return request({
    url: '/api/qywechat/getLicensePoint',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}
// 启用账号
export function userEnable(userId,authorization){
  return request({
    url: '/api/qywechat/license/enable/'+ userId,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}
// 停用（许可账号转接）
export function disEnable(params,authorization){
  return request({
    url: 'api/qywechat/license/disEnable',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  })
}
// 继承许可账号是否超过30天
export function isTransfer(userId,authorization){
  return request({
    url: '/api/qywechat/license/isTransfer/'+userId,
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}
// 选择成员列表
export function getLicenseDepartStaff(params,authorization){
  return request({
    url: '/api/qywechat/getLicenseDepartStaff',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  })
}
// 根据员工姓名关键字查询
export function getLicenseFuSearch(params,authorization,isloading){
  return request({
    url: '/api/qywechat/getLicenseFuSearch',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}



// 获取新旧版客莱宝版本
export function getSessionVersion(authorization){
  return request({
    url: '/api/qywechat/getSessionVersion',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}

/** 新版获取员工列表 */
export function getAuthUserList(data,authorization){
  return request({
    url: '/api/qywechat/getAuthUserList',
    method: 'post',
    data,
    headers: {
      "authorization": authorization
    }
  })
}



// export function getAuthUserList(data,authorization){
//   return request({
//     url: '/api/qywechat/getAuthUserList',
//     method: 'post',
//     data,
//     headers: {
//       "authorization": authorization
//     }
//   })
// }
/** 新版获取员工外部好友列表 */
export function getAuthUserCustomerList(pram,Authorization,isloading) {
  return request({
    url: '/api/qywechat/getAuthUserCustomerList/' + pram.sendFrom + '/' + pram.current + '/' + pram.size + '/' + pram.startTime + '/' + pram.endTime ,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  },true)
}
 

// 获取新版会话数据 
export function getFileSessionKey(sendFrom,sendTo,current,size, Authorization,isloading,msgType,start="",end="",) {
  let url = `/api/qywechat/getFileSessionKey/${sendFrom}/${sendTo}/${current}/${size}?start=${start}&end=${end}&msgType=${msgType}`
    // let url = '/api/qywechat/getFileSessionKey/'+sendFrom+'/'+sendTo+'/'+current+'/'+ size+'?start='+start+'&end='+ end
    // if(msgType) {
    //   url = url + `?msgType=${msgType}`
    // }
  return request({
    url,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  },true)
}



// export function getFileSessionKeyList(pram,Authorization,isloading){
//   return request({
//     url: `/api/qywechat/getFileSessionKey/${pram}/${pram}`,
//     method: 'post',
//     headers: {
//       "authorization": Authorization
//     }
//   },isloading)
// }



